import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { toast } from "sonner";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const sessionId = new URLSearchParams(hash.substring(1)).get("session_id");

        if (!sessionId) {
          toast.error("Erro na autenticação");
          navigate("/");
          return;
        }

        // Exchange session_id for JWT token
        const response = await axios.post(
          `${API}/auth/google/session?session_id=${encodeURIComponent(sessionId)}`
        );

        const { token, user, is_new_user } = response.data;

        // Set auth state
        setAuth(token, user);

        // Show appropriate message
        if (is_new_user) {
          toast.success("Conta criada com sucesso! Bem-vindo(a) ao altalab!");
        } else {
          toast.success("Login realizado com sucesso!");
        }

        // Redirect based on onboarding status
        if (is_new_user || !user.onboarding_completed) {
          navigate("/onboarding");
        } else {
          navigate("/home");
        }
      } catch (error) {
        console.error("Auth callback error:", error);
        toast.error(error.response?.data?.detail || "Erro na autenticação com Google");
        navigate("/");
      }
    };

    processAuth();
  }, [navigate, setAuth]);

  return (
    <div className="min-h-screen bg-[#050505] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-12 h-12 text-[#FD5564] animate-spin mx-auto mb-4" />
        <p className="text-white/60">Autenticando com Google...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
